import { GetPublicOauth2IntegrationForChannel, GetSSOIntegrationsForChannel } from '@/connection/integrations/oauth';
import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { ISSOIntegration, Oauth2Integration } from '@/types/registration.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { useEffect, useState } from 'react';

export default function useLoadSSOs() {
  const activeChannel = useAppSelector(getActiveChannel);
  const [ssos, setSsos] = useState<ISSOIntegration[]>([]);
  const [publicOauthIntegration, setPublicOauthIntegration] = useState<Oauth2Integration | null>(null);

  useEffect(() => {
    if (!activeChannel) {
      return;
    }

    // Reset the state when the channel changes
    setSsos([]);
    setPublicOauthIntegration(null);

    (async () => {
      try {
        const [ssos, publicOauthIntegration] = await Promise.all([
          GetSSOIntegrationsForChannel(activeChannel),
          GetPublicOauth2IntegrationForChannel(activeChannel),
        ]);
        setSsos(ssos);
        setPublicOauthIntegration(publicOauthIntegration || null);
      } catch (error) {
        console.error(error);
        toastTrigger('Error loading SSOs', {
          type: 'error',
          toastId: 'sso-loading-errors',
        });
      }
    })();
  }, [activeChannel]);

  return { ssos, publicOauthIntegration };
}
